<div class="relative ps-medium-t" [class.disabled]="disabled" [formGroup]="group">
  <input
    #inputElement
    [id]="name"
    [formControlName]="modelName"
    [class.form-field-empty]="!(group.get(modelName)?.value?.length > 0)"
    [attr.name]="name"
    [attr.type]="inputType"
    [attr.pattern]="inputPattern"
    [attr.autocomplete]="autocomplete"
    [attr.disabled]="disabled ? 'disabled' : null"
    (blur)="onBlur()"
    (change)="onChangeEvent($event)"
    (focus)="focus.emit([translationPrefix, 'info'].join('.'))"
    (keydown.enter)="onEnter()"
    (paste)="onPaste()"
  />
  <label [attr.for]="name" class="font-body-2 overflow-hidden truncate">
    @if (hiddenLabel) {
      <span class="is-vishidden" aria-hidden="true">{{ hiddenLabel }}</span>
    }
    <span>
      {{ [translationPrefix, 'label'].join('.') | finLocalization }}
      @if (required) {
        <span> *</span>
      }
    </span>
  </label>
</div>

@if (!this.hideError && this.group.get(this.modelName)?.invalid && this.group.get(this.modelName)?.touched) {
  <div class="error-label font-body-2">
    <span class="error-900-text">
      {{ [translationPrefix, firstError().key].join('.') | finLocalization: firstError().data }}
    </span>
  </div>
}
